// live-upcoming-auctions.js — catalogues carousel (Liquid) + Live / Upcoming lot grids below.
document.addEventListener('DOMContentLoaded', function () {
  if (location.pathname.indexOf('/collections/live-upcoming-auctions') !== 0) return;

  function syncLiveUpcomingHeroCatalogueCount(carouselEl) {
    var hero = document.getElementById('sta-hero-catalogue-lots-label');
    if (!hero || !carouselEl) return;
    var n = parseInt(carouselEl.getAttribute('data-live-catalogue-count') || '0', 10);
    if (!n) {
      n = carouselEl.querySelectorAll('.sta-products-carousel__product.swiper-slide').length;
    }
    if (n > 0) {
      hero.textContent = n === 1 ? '1 Catalogue' : n + ' Catalogues';
      hero.removeAttribute('data-collection-count');
    }
  }

  var liveCataloguesCarousel = document.querySelector('[data-live-catalogues-carousel]');
  var container = document.getElementById('sta-live-upcoming-lot-grids-mount');

  if (!container && liveCataloguesCarousel) {
    container = document.createElement('div');
    container.id = 'sta-live-upcoming-lot-grids-mount';
    container.setAttribute('data-live-upcoming-lot-grids-mount', '');
    var sectionRoot = liveCataloguesCarousel.closest('.shopify-section');
    if (sectionRoot) {
      sectionRoot.insertAdjacentElement('afterend', container);
    } else {
      liveCataloguesCarousel.insertAdjacentElement('afterend', container);
    }
  }

  if (!container && !liveCataloguesCarousel) {
    container =
      document.querySelector('.sta-collection-products') ||
      document.querySelector('.collection.page-width') ||
      document.querySelector('main') ||
      document.body;
  }

  if (!container) {
    container = document.querySelector('main') || document.body;
  }

  if (liveCataloguesCarousel) {
    syncLiveUpcomingHeroCatalogueCount(liveCataloguesCarousel);
  }

  function parseCollectionHandles(raw) {
    return String(raw || '')
      .split('+')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
  }

  /** Live + upcoming lots for one auction catalogue (matches hidden product map). */
  function countLiveUpcomingLotsForHandle(handle) {
    if (!handle) return 0;
    var nowSec = Math.floor(Date.now() / 1000);
    // The catalogue card outlives its last lot by the hold window -- otherwise it
    // disappears the second that lot closes while the lot is still on the catalogue
    // page for another 24h. Read from sta-auctions-api.js so the two cannot drift.
    var holdSec = Math.floor((window.staEndedLotHoldMs || 24 * 60 * 60 * 1000) / 1000);
    var count = 0;
    document.querySelectorAll('ul.urls-check-cards-products li[data-product-id]').forEach(function (li) {
      var handleList = parseCollectionHandles(li.getAttribute('data-collection-handles-of-products'));
      if (handleList.indexOf(handle) === -1) return;
      var startTs = parseInt(li.getAttribute('data-auction-start-ts') || '0', 10) || 0;
      var endTs = parseInt(li.getAttribute('data-auction-end-ts') || '0', 10) || 0;
      if (!startTs || !endTs) return;
      // An unsold lot becomes Buy Now the moment its auction ends but stays on the
      // catalogue page for the hold, so it keeps counting until the hold is over.
      if (li.getAttribute('data-buy-now') === 'true' && endTs > nowSec) return;
      // A closed lot still counts for the length of the hold, so the catalogue keeps its
      // card for exactly as long as its lots keep their place on the catalogue page.
      if (endTs <= nowSec) {
        if (nowSec - endTs < holdSec) count++;
        return;
      }
      if (startTs <= nowSec && nowSec < endTs) count++;
      else if (nowSec < startTs) count++;
    });
    return count;
  }

  function formatLotCountLabel(n) {
    n = n == null || isNaN(+n) ? 0 : +n;
    return n === 1 ? '1 Lot' : n + ' Lots';
  }

  function syncCatalogueCardLotCounts() {
    if (window.staSyncCatalogueCardLotCounts) {
      window.staSyncCatalogueCardLotCounts();
      return;
    }
    document.querySelectorAll('[data-catalogue-lot-count]').forEach(function (el) {
      var handle = (el.getAttribute('data-catalogue-lot-count') || '').trim();
      if (!handle) return;
      var n = countLiveUpcomingLotsForHandle(handle);
      el.textContent = formatLotCountLabel(n);
      var slide = el.closest('[data-catalogue-carousel-slide], .sta-products-grid__cell, .sta-products-carousel__product.swiper-slide');
      if (!slide) return;
      if (n <= 0) {
        slide.hidden = true;
        slide.style.display = 'none';
      } else {
        slide.hidden = false;
        slide.style.display = '';
      }
    });
  }

  syncCatalogueCardLotCounts();

  var API_BASE = (window.staAuctionsBase ? window.staAuctionsBase() : localStorage.getItem('sterlings_base_url') || '').replace(/\/+$/, '');
  var headers = window.staAuctionHeaders ? window.staAuctionHeaders() : { Accept: 'application/json' };

  function formatMoneyHtml(dollars) {
    return window.staFormatMoney ? window.staFormatMoney(dollars) : '<small>$</small>' + dollars + '<span class="sta-money__code"> CAD</span>';
  }

  function setMoneyPrice(el, dollars) {
    if (!el) return;
    if (window.staSetMoneyEl) window.staSetMoneyEl(el, dollars);
    else el.innerHTML = formatMoneyHtml(dollars);
  }

  function normalizeUrlWithAuctionId(url, auctionId) {
    if (!url || url === '#') return '#';
    var isAbs = /^https?:\/\//i.test(url);
    var isProductsPath = /^\/?products\//i.test(url);
    if (!isAbs) {
      url = isProductsPath
        ? (url.startsWith('/') ? url : '/' + url)
        : '/products/' + url.replace(/^\/+/, '');
      url = new URL(url, window.location.origin).href;
    }
    try {
      var u = new URL(url);
      if (auctionId != null && String(auctionId).trim() !== '') {
        u.searchParams.set('auction_id', String(auctionId));
      }
      return u.toString();
    } catch (_) {
      return url;
    }
  }

  // Card date + exact time, e.g. "7/24/2026 at 2:00 P.M EDT" (visitor
  // locale/timezone, timezone label from sta-time.js).
  function fmtDateTime(d) {
    if (window.staFormatDateTime) return window.staFormatDateTime(d, 'short');
    try {
      return d.toLocaleString();
    } catch (e) {
      return '';
    }
  }

  function startCountdown(el, iso, labelWhenDone) {
    var p = el.querySelector('p') || el.appendChild(document.createElement('p'));
    function render() {
      var ts = Date.parse(iso || '');
      if (!isFinite(ts)) {
        p.textContent = '';
        return;
      }
      var s = Math.max(0, Math.floor((ts - Date.now()) / 1000));
      var d = Math.floor(s / 86400);
      s -= d * 86400;
      var h = Math.floor(s / 3600);
      s -= h * 3600;
      var m = Math.floor(s / 60);
      var sec = s % 60;
      p.textContent =
        d + h + m + sec <= 0
          ? labelWhenDone || 'Ended'
          : d + 'd ' + String(h).padStart(2, '0') + 'h ' + String(m).padStart(2, '0') + 'm ' + String(sec).padStart(2, '0') + 's';
    }
    render();
    var t = setInterval(render, 1000);
    var mo = new MutationObserver(function () {
      if (!document.body.contains(el)) {
        clearInterval(t);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function rowAttrs(row) {
    return row && row.attributes ? row.attributes : row || {};
  }

  function attrsFromShowPayload(payload) {
    if (!payload) return null;
    var data = payload.data && !Array.isArray(payload.data) ? payload.data : payload;
    if (!data) return null;
    var attrs = data.attributes || data;
    return {
      row: { id: data.id, attributes: attrs },
      attrs: attrs,
    };
  }

  function fetchAuctionById(auctionId) {
    if (!auctionId || !API_BASE) return Promise.resolve(null);
    var customerId = window.staCurrentCustomerId ? window.staCurrentCustomerId() : '';
    var path = window.staAuctionShowPath
      ? window.staAuctionShowPath(auctionId, customerId)
      : '/api/auctions/' + encodeURIComponent(String(auctionId));
    var fullUrl = API_BASE + path;
    return fetch(fullUrl, {
      headers: headers,
      mode: 'cors',
    })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  /** 24h ended-lot hold, in seconds — shared with the catalogue grids. */
  function holdSec() {
    var ms = window.staEndedLotHoldMs || 24 * 60 * 60 * 1000;
    return Math.floor(ms / 1000);
  }

  /** Collect auction lots from theme.liquid hidden map (Shopify catalogue + dates). */
  function collectShopifyAuctionLots() {
    var nowSec = Math.floor(Date.now() / 1000);
    var holdCutoff = nowSec - holdSec();
    var lots = [];

    document.querySelectorAll('ul.urls-check-cards-products li[data-product-id]').forEach(function (li) {
      var startTs = parseInt(li.getAttribute('data-auction-start-ts') || '0', 10) || 0;
      var endTs = parseInt(li.getAttribute('data-auction-end-ts') || '0', 10) || 0;
      if (!startTs || !endTs) return;
      // A finished lot keeps its place for 24h showing its result; a Buy Now lot only
      // belongs here while it is inside that hold.
      if (endTs <= holdCutoff) return;
      var isBuyNow = li.getAttribute('data-buy-now') === 'true';
      if (isBuyNow && endTs > nowSec) return;

      var handles = String(li.getAttribute('data-collection-handles-of-products') || '').trim();
      if (!handles) return;

      lots.push({
        productId: String(li.getAttribute('data-product-id') || '').trim(),
        href: String(li.getAttribute('data-href') || '').trim(),
        startTs: startTs,
        endTs: endTs,
        auctionApiId: String(li.getAttribute('data-auction-api-id') || '').trim(),
        title: String(li.getAttribute('data-product-title') || '').trim(),
        sku: String(li.getAttribute('data-product-sku') || '').trim(),
        image: String(li.getAttribute('data-product-image') || '').trim(),
        priceCents: parseInt(li.getAttribute('data-store-price-cents') || '0', 10) || 0,
        buyNow: isBuyNow,
        lotSold: li.getAttribute('data-lot-sold') === 'true',
      });
    });

    return lots;
  }

  function partitionLots(lots, nowSec) {
    var live = [];
    var upcoming = [];
    var ended = [];
    lots.forEach(function (lot) {
      if (lot.startTs <= nowSec && nowSec < lot.endTs) live.push(lot);
      else if (nowSec < lot.startTs && nowSec < lot.endTs) upcoming.push(lot);
      else if (lot.endTs <= nowSec) ended.push(lot);
    });
    live.sort(function (a, b) {
      return a.endTs - b.endTs;
    });
    upcoming.sort(function (a, b) {
      return a.startTs - b.startTs;
    });
    // Most recently ended first: the freshest result leads the held lots.
    ended.sort(function (a, b) {
      return b.endTs - a.endTs;
    });
    return { live: live, upcoming: upcoming, ended: ended };
  }

  function lotToFallbackRow(lot) {
    var startIso = new Date(lot.startTs * 1000).toISOString();
    var endIso = new Date(lot.endTs * 1000).toISOString();
    var price = lot.priceCents > 0 ? lot.priceCents / 100 : 0;
    var productUrl = lot.href
      ? new URL(lot.href.startsWith('/') ? lot.href : '/' + lot.href, window.location.origin).href
      : '#';
    return {
      id: lot.auctionApiId || null,
      attributes: {
        product_name: lot.title || 'Auction Item',
        product_sku: lot.sku,
        product_image_url: lot.image,
        product_url: productUrl,
        start_date: startIso,
        end_date: endIso,
        current_price: price,
        initial_price: price,
        bids_count: 0,
      },
    };
  }

  function fetchAuctionByProductId(productId) {
    if (!productId || !API_BASE) {
      return Promise.resolve(null);
    }
    var listUrl =
      API_BASE + '/api/auctions?product_ids=' + encodeURIComponent(String(productId));
    var fetchFn = window.staFetchAuctionsByProductIds
      ? window.staFetchAuctionsByProductIds([productId], { perPage: 1 })
      : fetch(listUrl, { headers: headers, mode: 'cors' }).then(function (r) {
          if (!r.ok) return null;
          return r.json();
        });
    return fetchFn
      .then(function (payload) {
        if (!payload) {
          return null;
        }
        var rows = window.staPickAuctionArray
          ? window.staPickAuctionArray(payload)
          : payload.data || [];
        if (!rows.length) return null;
        var row = rows[0];
        return attrsFromShowPayload({ data: row });
      })
      .catch(function () {
        return null;
      });
  }

  function enrichLot(lot) {
    if (lot.auctionApiId) {
      return fetchAuctionById(lot.auctionApiId).then(function (payload) {
        var parsed = attrsFromShowPayload(payload);
        if (parsed && parsed.row) {
          return parsed.row;
        }
        return lotToFallbackRow(lot);
      });
    }
    if (lot.productId) {
      return fetchAuctionByProductId(lot.productId).then(function (parsed) {
        if (parsed && parsed.row) {
          return parsed.row;
        }
        return lotToFallbackRow(lot);
      });
    }
    return Promise.resolve(lotToFallbackRow(lot));
  }

  var CARD_HTML =
    '\
<div class="sta-collection-products__product">\
  <div class="sta-product-card">\
    <div class="sta-product-card__header">\
      <a href="#" class="sta-product-card__ill">\
        <img src="" alt="" class="sta-product-card__img" loading="lazy">\
      </a>\
      <span class="sta-product-card__badge sta-product-badge" style="display:none;">\
        <span class="sta-product-badge__name"></span>\
      </span>\
      <button class="sta-product-card__to-wish sta-wish-btn" title="Add to wishlist" aria-label="Add to wishlist"></button>\
    </div>\
    <div class="sta-product-card__body">\
      <h3 class="sta-product-card__title"><a href="#">Auction Item</a></h3>\
      <div class="sta-product-card__auction"><span data-auction-label>Auction</span></div>\
    </div>\
    <div class="sta-product-card__info">\
      <div class="sta-product-card__info-row sta-product-card__info-row--no-estimate">\
        <div class="sta-product-specs">\
        <div class="sta-product-spec">\
          <span class="sta-product-spec__ico"></span>\
          <div class="sta-product-spec__body">\
            <div class="sta-product-spec__title">SKU: —</div>\
          </div>\
        </div>\
        <div class="sta-product-spec">\
          <svg class="svg-ico sta-product-spec__ico">\
            <use xlink:href="//sterlingauctions.com/cdn/shop/t/3/assets/sprite.svg#stopwatch"></use>\
          </svg>\
          <div class="sta-product-spec__body">\
            <div class="sta-product-spec__title">—</div>\
            <p></p>\
          </div>\
        </div>\
        </div>\
        <div class="sta-product-card__estimate-slot" data-price-estimate-slot hidden></div>\
      </div>\
    </div>\
    <div class="sta-product-card__footer">\
      <div class="sta-product-card__bid-status" data-sta-bid-status-slot></div>\
      <div class="sta-product-card__price">\
        <div class="sta-product-spec__body sta-product-price">\
          <div class="sta-product-price__title">—</div>\
          <div class="sta-product-price__price"><small>$</small>0<span class="sta-money__code"> CAD</span></div>\
        </div>\
        <div class="sta-product-card__bids">\
          <svg class="svg-ico sta-product-card__bids-ico"><use xlink:href="//sterlingauctions.com/cdn/shop/t/3/assets/sprite.svg#auction-hammer"></use></svg>\
          <div class="sta-product-card__bids-body">\
            <div class="sta-product-card__bids-count">0</div>\
            <div>Bids</div>\
          </div>\
        </div>\
      </div>\
      <a href="#" class="sta-btn _secondary _full center">—</a>\
    </div>\
  </div>\
</div>';

  function buildCard() {
    var t = document.createElement('div');
    t.innerHTML = CARD_HTML.trim();
    return t.firstElementChild;
  }

  function fillCard(row, mode, lotFallback) {
    var a = rowAttrs(row);
    var card = buildCard();

    var name = a.auction_name || a.product_name || a.name || (lotFallback && lotFallback.title) || 'Auction Item';
    var sku = a.product_sku || (lotFallback && lotFallback.sku) || '';
    var img = a.product_image_url || (lotFallback && lotFallback.image) || '';
    var url = a.product_url || (lotFallback && lotFallback.href) || '#';
    var aid = (row && row.id) || a.auction_id || a.id || (lotFallback && lotFallback.auctionApiId) || null;

    var startIso = a.start_date || a.start_at || null;
    var endIso = a.end_date || a.end_at || null;
    if (!startIso && lotFallback) startIso = new Date(lotFallback.startTs * 1000).toISOString();
    if (!endIso && lotFallback) endIso = new Date(lotFallback.endTs * 1000).toISOString();

    var storeDollars =
      lotFallback && lotFallback.priceCents > 0 ? lotFallback.priceCents / 100 : null;
    var price = window.staAuctionDisplayPrice
      ? window.staAuctionDisplayPrice(a, storeDollars)
      : storeDollars;
    var bids = a.bid_count || a.bids_count || 0;

    url = normalizeUrlWithAuctionId(url, aid);

    var link = card.querySelector('.sta-product-card__ill');
    if (link) link.href = url;
    var imgEl = card.querySelector('.sta-product-card__img');
    if (imgEl) {
      if (img) {
        imgEl.src = img;
        imgEl.alt = name;
        imgEl.removeAttribute('srcset');
      } else {
        imgEl.removeAttribute('src');
      }
    }

    var titleA = card.querySelector('.sta-product-card__title a');
    if (titleA) {
      titleA.textContent = name;
      titleA.href = url;
    }
    var pill = card.querySelector('.sta-product-card__auction [data-auction-label]');

    var skuTitle = card.querySelector('.sta-product-spec__title');
    if (skuTitle) skuTitle.textContent = sku ? 'SKU: ' + sku : 'SKU: —';

    var badge = card.querySelector('.sta-product-card__badge');
    var timingBody = card.querySelectorAll('.sta-product-spec__body')[1] || card.querySelector('.sta-product-spec__body');
    var timingTitle = timingBody ? timingBody.querySelector('.sta-product-spec__title') : null;

    var priceTitle = card.querySelector('.sta-product-price__title');
    var priceEl = card.querySelector('.sta-product-price__price');
    var bidsEl = card.querySelector('.sta-product-card__bids-count');
    var cta = card.querySelector('.sta-btn._secondary') || card.querySelector('.sta-btn');

    if (mode === 'ended') {
      // Inside the 24h hold: display only, never biddable. Same wording as the
      // catalogue cards in live-auctions.js.
      var hasWinner = !!(window.staHasAuctionWinner && window.staHasAuctionWinner(a));
      var isSold = hasWinner || !!(lotFallback && lotFallback.lotSold);
      var isBuyNowLot = !isSold && !!(lotFallback && lotFallback.buyNow) && storeDollars != null;

      if (badge) {
        badge.classList.remove('_live', '_upcoming');
        if (isSold) {
          badge.style.display = '';
          badge.classList.add('_sold');
          badge.querySelector('.sta-product-badge__name').textContent = 'Sold';
        } else {
          badge.style.display = 'none';
        }
      }
      if (pill) pill.textContent = 'Past Auction';
      if (timingTitle) timingTitle.textContent = isBuyNowLot ? 'Buy now' : 'Ended';
      if (timingBody) {
        var timingP = timingBody.querySelector('p');
        if (timingP) timingP.textContent = '';
      }
      if (priceTitle) {
        priceTitle.textContent = isSold
          ? 'Hammer price:'
          : isBuyNowLot
            ? 'Buy now price:'
            : 'Latest bid:';
      }
      if (priceEl) {
        var endedPrice = isBuyNowLot ? storeDollars : price;
        if (endedPrice != null) setMoneyPrice(priceEl, endedPrice);
        else priceEl.innerHTML = '';
      }
      if (bidsEl) bidsEl.textContent = bids;
      if (cta) {
        cta.href = url;
        cta.textContent = isBuyNowLot ? 'Buy Now' : 'Lot Details';
        // Red is for live lots; ended ones take the plain blue button.
        cta.classList.remove('_secondary');
      }
    } else if (mode === 'live') {
      if (badge) {
        badge.style.display = '';
        badge.classList.add('_live');
        badge.classList.remove('_upcoming');
        badge.querySelector('.sta-product-badge__name').textContent = 'Live';
      }
      if (pill) pill.textContent = 'Live Auction';
      if (timingTitle && endIso) {
        var d = new Date(endIso);
        timingTitle.textContent = 'Ends ' + fmtDateTime(d);
      }
      if (timingBody && endIso) startCountdown(timingBody, endIso, 'Ended');
      if (priceTitle) {
        priceTitle.textContent = window.staAuctionLivePriceLabel
          ? window.staAuctionLivePriceLabel(bids)
          : 'Current bid:';
      }
      if (priceEl && price != null) setMoneyPrice(priceEl, price);
      if (bidsEl) bidsEl.textContent = bids;
      if (cta) {
        cta.href = url;
        cta.textContent = 'Place Bid';
        cta.classList.add('_secondary');
      }
    } else {
      if (badge) {
        badge.style.display = '';
        badge.classList.remove('_live');
        // "Upcoming" is too long for the badge circle — _upcoming scales the type down to fit.
        badge.classList.add('_upcoming');
        badge.querySelector('.sta-product-badge__name').textContent = 'Upcoming';
      }
      if (pill) pill.textContent = 'Upcoming Auction';
      if (timingTitle && startIso) {
        var s = new Date(startIso);
        timingTitle.textContent = 'Starts ' + fmtDateTime(s);
      }
      if (timingBody && startIso) startCountdown(timingBody, startIso, 'Starting soon');
      if (priceTitle) priceTitle.textContent = aid ? 'Starting bid:' : '—';
      if (priceEl) {
        if (aid && price != null) setMoneyPrice(priceEl, price);
        else priceEl.innerHTML = '';
      }
      if (bidsEl) bidsEl.textContent = 0;
      if (cta) {
        cta.href = url;
        // Upcoming lots: always "Preview" with the blue CTA (see .sta-btn--preview).
        cta.textContent = 'Preview';
        cta.classList.add('sta-btn--preview');
      }
    }

    if (window.staApplyPriceEstimateToCard) {
      var pid = window.staProductIdFromAuctionAttrs
        ? window.staProductIdFromAuctionAttrs(a, lotFallback)
        : (lotFallback && lotFallback.productId) || '';
      window.staApplyPriceEstimateToCard(card, pid);
    }

    var wishBtn = card.querySelector('.sta-wish-btn');
    var wishProductId = window.staProductIdFromAuctionAttrs
      ? window.staProductIdFromAuctionAttrs(a, lotFallback)
      : (lotFallback && lotFallback.productId) || '';
    if (wishBtn && wishProductId) {
      wishBtn.setAttribute('data-product-id', wishProductId);
      wishBtn.setAttribute('type', 'button');
    }

    return card;
  }

  function section(titleText, id) {
    var wrap = document.createElement('div');
    wrap.className = 'sta-collection-products';
    wrap.classList.add('page-width');
    var h2 = document.createElement('h2');
    h2.className = 'section__title sta-collection__section-title';
    h2.textContent = titleText;
    var grid = document.createElement('div');
    grid.id = id;
    grid.className = 'sta-collection-products__grid collection';
    grid.innerHTML = '<div style="padding:12px;opacity:.6">Loading…</div>';
    wrap.appendChild(h2);
    wrap.appendChild(grid);
    return { wrap: wrap, grid: grid };
  }

  function countVisibleLotCards(grid) {
    if (!grid) return 0;
    var n = 0;
    grid.querySelectorAll(':scope > .sta-collection-products__product').forEach(function (el) {
      try {
        if (window.getComputedStyle(el).display === 'none') return;
      } catch (e) {}
      n++;
    });
    return n;
  }

  function syncLiveUpcomingHeroLots() {
    var hero = document.getElementById('sta-hero-catalogue-lots-label');
    if (!hero) return;
    var n =
      countVisibleLotCards(document.getElementById('live-auctions-grid')) +
      countVisibleLotCards(document.getElementById('upcoming-auctions-grid'));
    hero.textContent = n === 1 ? '1 Lot' : n + ' Lots';
  }

  function renderGrid(grid, lots, mode, emptyMessage) {
    grid.innerHTML = '';
    if (!lots.length) {
      var empty = document.createElement('div');
      empty.style.padding = '12px';
      empty.textContent = emptyMessage;
      grid.appendChild(empty);
      return Promise.resolve();
    }

    var nowSec = Math.floor(Date.now() / 1000);
    return Promise.all(lots.map(enrichLot)).then(function (rows) {
      rows.forEach(function (row, idx) {
        var lot = lots[idx];
        var cardMode = mode === 'live' && lot && lot.endTs <= nowSec ? 'ended' : mode;
        grid.appendChild(fillCard(row, cardMode, lot));
      });
      if (window.staWishlistSyncButtons) window.staWishlistSyncButtons();
    });
  }

  var liveSec = section('Live Auctions', 'live-auctions-grid');
  var upcSec = section('Upcoming Auctions', 'upcoming-auctions-grid');

  container.innerHTML = '';
  container.appendChild(liveSec.wrap);
  container.appendChild(upcSec.wrap);

  var allLots = collectShopifyAuctionLots();
  var parts = partitionLots(allLots, Math.floor(Date.now() / 1000));

  Promise.all([
    // Live first (soonest ending first), then lots inside their 24h hold.
    renderGrid(liveSec.grid, parts.live.concat(parts.ended), 'live', 'No live auctions right now.'),
    renderGrid(upcSec.grid, parts.upcoming, 'upcoming', 'No upcoming auctions scheduled.'),
  ]).then(function () {
    if (document.getElementById('sta-hero-catalogue-lots-label')) {
      syncLiveUpcomingHeroLots();
    }
    syncCatalogueCardLotCounts();
  });

  document.addEventListener('sta:auctions-synced', syncCatalogueCardLotCounts);
  setTimeout(syncCatalogueCardLotCounts, 1500);
});
